import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
interface MeasurementToolsProps {
  onAddWall: (wall: any) => void;
}
export function MeasurementTools({
  onAddWall
}: MeasurementToolsProps) {
  const [wallLength, setWallLength] = useState(300);
  const [wallAngle, setWallAngle] = useState(90);
  const handleAddManualWall = () => {
    // Add a wall with specific length and angle
    // This is a simplified version - in a real app, you'd need to calculate
    // the actual coordinates based on the previous wall's end point
    onAddWall({
      start: {
        x: 100,
        y: 100
      },
      end: {
        x: 100 + wallLength,
        y: 100
      },
      length: wallLength
    });
  };
  return <div className="space-y-4" data-id="element-401">
      <div data-id="element-402">
        <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-403">Add Wall</h3>
        <p className="text-xs text-gray-500 mb-4" data-id="element-404">
          Add a wall by drawing on the canvas or setting precise measurements
        </p>
        <div className="space-y-3" data-id="element-405">
          <div data-id="element-406">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-407">
              Length (cm)
            </label>
            <div className="flex items-center" data-id="element-408">
              <button onClick={() => setWallLength(prev => Math.max(prev - 10, 10))} className="p-1 bg-gray-100 text-gray-600 rounded-l-md border border-gray-300" data-id="element-409">
                <MinusIcon className="h-4 w-4" data-id="element-410" />
              </button>
              <input type="number" value={wallLength} onChange={e => setWallLength(Number(e.target.value))} className="border-t border-b border-gray-300 py-1 px-2 text-center w-16 text-sm" data-id="element-411" />
              <button onClick={() => setWallLength(prev => prev + 10)} className="p-1 bg-gray-100 text-gray-600 rounded-r-md border border-gray-300" data-id="element-412">
                <PlusIcon className="h-4 w-4" data-id="element-413" />
              </button>
            </div>
          </div>
          <div data-id="element-414">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-415">
              Angle (degrees)
            </label>
            <div className="flex items-center" data-id="element-416">
              <button onClick={() => setWallAngle(prev => Math.max(prev - 5, 0))} className="p-1 bg-gray-100 text-gray-600 rounded-l-md border border-gray-300" data-id="element-417">
                <MinusIcon className="h-4 w-4" data-id="element-418" />
              </button>
              <input type="number" value={wallAngle} onChange={e => setWallAngle(Number(e.target.value))} className="border-t border-b border-gray-300 py-1 px-2 text-center w-16 text-sm" data-id="element-419" />
              <button onClick={() => setWallAngle(prev => Math.min(prev + 5, 360))} className="p-1 bg-gray-100 text-gray-600 rounded-r-md border border-gray-300" data-id="element-420">
                <PlusIcon className="h-4 w-4" data-id="element-421" />
              </button>
            </div>
          </div>
          <button onClick={handleAddManualWall} className="w-full py-2 px-4 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 flex items-center justify-center text-sm" data-id="element-422">
            <PlusIcon className="h-4 w-4 mr-1" data-id="element-423" />
            <span data-id="element-424">Add Wall</span>
          </button>
        </div>
      </div>
      <div className="border-t border-gray-200 pt-4" data-id="element-425">
        <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-426">Tips</h3>
        <ul className="text-xs text-gray-500 space-y-1 list-disc list-inside" data-id="element-427">
          <li data-id="element-428">Draw walls in clockwise direction</li>
          <li data-id="element-429">Use zoom buttons to adjust the scale</li>
          <li data-id="element-430">
            Ensure the room is closed (last wall connects to starting point)
          </li>
          <li data-id="element-431">Use the grid to help with wall placement</li>
        </ul>
      </div>
    </div>;
}